"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.Spinner = exports.ErrorMsg = exports.stripSpaces = void 0;
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
exports.stripSpaces = function (str) {
    return str.replace(/\s/g, '');
};
exports.ErrorMsg = function (props) {
    return (React.createElement(react_transition_group_1.CSSTransitionGroup, { className: 'error-msg-container', transitionName: 'appear', transitionAppearTimeout: 200, transitionEnterTimeout: 200, transitionLeaveTimeout: 200 }, props.isVisible ? React.createElement("span", { role: 'alert', className: 'error-msg' }, props.msg) : null));
};
exports.Spinner = function () { return (React.createElement("div", { className: 'spinner' },
    React.createElement("div", { className: 'bounce1' }),
    React.createElement("div", { className: 'bounce2' }),
    React.createElement("div", { className: 'bounce3' }))); };
exports.delay = function (retryDelay) { return new Promise(function (res) { return setTimeout(res, retryDelay); }); };
//# sourceMappingURL=contact-form-utils.js.map